import { ReactNode } from 'react';
import styles from './work-order-field.module.scss';

interface WorkOrderFieldProps {
  title: string;
  value: ReactNode;
}

export const WorkOrderField = ({ title, value }: WorkOrderFieldProps) => {
  return (
    <div className={styles.workOrderFieldContainer}>
      <span className={styles.workOrderFieldTitle}>{title}</span>
      <span className={styles.workOrderFieldValue}>{value}</span>
    </div>
  );
};
